module.exports = __webpack_public_path__ + "img/bg_dashboard_card.8195aec7.svg";